import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

export default class CommentedOnFilesMessage extends React.PureComponent {
    static get propTypes() {
        return {

            /*
         * The file ids of the post that was commented on
         */
            parentPostFileIds: PropTypes.arrayOf(PropTypes.string),

            /*
         * An array of file metadata for the parent post
         */
            fileInfos: PropTypes.arrayOf(PropTypes.object),
        };
    }

    render() {
        if (!this.props.fileInfos || this.props.fileInfos.length === 0) {
            return null;
        }

        let plusMore = null;
        if (this.props.fileInfos.length > 1) {
            plusMore = (
                <FormattedMessage
                    id='post_body.plusMore'
                    defaultMessage=' plus {count, number} other {count, plural, one {file} other {files}}'
                    values={{
                        count: this.props.fileInfos.length - 1,
                    }}
                />
            );
        }

        return (
            <span>
                {this.props.fileInfos[0].name}
                {plusMore}
            </span>
        );
    }
}
